// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__FovHF","footerText":"footer_footerText__kz_7U","lokeImage":"footer_lokeImage__fsjRy"};